<template>
<!-- 退费列表 -->
	<div class="">
	<van-radio-group v-model="select">
		<div class="form" v-for="(item, index) in dataList" :key="index">
        <div class="title">
          <div>
            <span>NO: {{ item.noticeNo }}</span>
          </div>
        </div>
        <div class="contentbox">
          <div>
            <span>执收单位：</span>
            <span>{{ item.deptName }}</span>
          </div>
          <div>
            <span>缴款单位/人：</span>
            <span>{{ item.paymentUnit }}</span>
          </div>
          <div>
            <span>证件号码：</span>
            <span>{{ item.idCard ? item.idCard : "未录入" }}</span>
          </div>
          <div class="remark">
            <span>备<span>证件</span>注：</span>
            <span class="remarkWord" @click="handleRemark(item.remark)">
              {{
              item.remark ? item.remark : "无"
              }}
            </span>
          </div>
          <div class="money">
            <span>金额：</span>
            <span>{{ item.paymentTotal }}元</span>
          </div>
		  <div>
            <span>缴费时间：</span>
            <span>{{ item.confirmDate ? item.confirmDate : "" }}</span>
          </div>
          <img :src="require('@/assets/img/confirm'+ item.isConfirm+'.png')" alt />
        </div>
        <div class="cu-form-group">
          <div @click="handleItem(item)">查看详情</div>
          <div @click="refunDetail(item)">退费账户</div>
        </div>
      </div>
	</van-radio-group>
	</div>
</template>

<script>
import { Toast,Dialog } from "vant";
	export default {
		props:['dataList','isTicket','checkedMark','isMerge'],
		data() {
			return {
				detailList:[],
				showModel:false,
				idx:0,
				select:-1,
				checkArr:[],
			}
		},
		created	() {
			const $this = this;
		},
		methods: {
			refunDetail(selectItem){
				// 退费账户
				// this.showModel = true
				this.$emit("refundChange", selectItem)
			},
			// 项目详情
			handleItem(selectItem,index) {
				// this.idx=index
				// this.showModel=true
				// this.detailList=selectItem.items
				// this.$forceUpdate()
				// this.$emit('func',this.showModel,this.detailList)
				this.showModel = true
				this.$emit("handleDetail", selectItem)
			},
			// 选择要支付的信息
			handleSelect(selectItem) {
				if (selectItem.checked  == false) {
					if (this.checkArr.length>0) {
						this.checkArr.find((item,i)=>{
							if (item.uId == selectItem.uId) {
								this.checkArr.splice(i,1);
								selectItem.checked = false;
								return;
							}
						})
					}
				}else {
					if (this.isMerge) { //合并支付
						if (selectItem.merchantType == '001' || selectItem.merchantType == '002' ||
						 (selectItem.merchantType == '003' && (selectItem.dataType == 1 || selectItem.dataType == 88))) {
							
							if (this.checkArr.length == 0) {
								selectItem.checked = true;
								this.checkArr.push(selectItem);

							}else {
									// 第一个选中的不是合并支付的数据
									if(this.checkArr[0].merchantType != '001' && this.checkArr[0].merchantType != '002' && this.checkArr[0].merchantType != '003') {
										this.dataList.forEach((val,index)=>{
											val.checked = false;
										})
										selectItem.checked = true;
										this.checkArr = [selectItem];
									}else {
										// 合并
										if (this.checkArr[0].deptId != selectItem.deptId ) {
											Dialog.alert({
												title: "提示",
												message:'执收单位不同，不能合并支付',
											}).then(() => {});
											selectItem.checked = false;
										}else if (this.checkArr[0].deptId == selectItem.deptId && selectItem.merchantType != this.checkArr[0].merchantType) {
											Dialog.alert({
												title: "提示",
												message:'只能合并同一个商户类型',
											}).then(() => {});
											selectItem.checked = false;
										}else if(this.checkArr[0].deptId == selectItem.deptId && selectItem.sysType != this.checkArr[0].sysType) {
											Dialog.alert({
												title: "提示",
												message:'只能合并同一个业务类型',
											}).then(() => {});
											selectItem.checked = false;
										}else if (this.checkArr[0].deptId == selectItem.deptId && selectItem.merchantType == this.checkArr[0].merchantType) {
												if (selectItem.merchantType == '003') {
													if ( selectItem.dataType != this.checkArr[0].dataType) {
														Dialog.alert({
															title: "提示",
															message:'只能合并同一个业务类型',
														}).then(() => {});
														selectItem.checked = false;
													}else {
														selectItem.checked = true;
														this.checkArr.push(selectItem)
													}
												}else {
													selectItem.checked = true;
													this.checkArr.push(selectItem)
												}
										}
									}
								
							}
		
						}else {
								this.dataList.forEach((val,index)=>{
									val.checked = false;
								})
								selectItem.checked = true;
								this.checkArr = [selectItem];
						}
					}else { //非合并支付
						this.dataList.forEach((val,index)=>{
							val.checked = false;
						})
						selectItem.checked = true;
						this.checkArr = [selectItem];
					}
				}
				this.$forceUpdate();
				this.$emit("checkArr",this.checkArr);
			},
			
			printNotice(index) {
				this.$emit('printNotice', index);
			},
			handleRemark(item) {
				if (item && item.length>13) {
					Dialog.alert({
						title: '备注',
						message: item,
					}).then(() => {
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	
.form {
  border-radius: 2px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
  border-radius: 5px;
  margin-bottom: 15px;
  .title {
    height: 40px;
    box-sizing: border-box;
    padding: 0 14px;
    line-height: 40px;
    border-radius: 8px 8px 0px 0px;
    background: #1989fa;
    span {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 31px;
    }
  }
  > .contentbox {
    padding: 5px 14px 0 14px;
    font-size: 14px;
    position: relative;
    > div {
      display: flex;
      align-items: flex-start;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #777777;
      line-height: 21px;
      justify-content: space-between;
      margin-top: 4px;
      span:nth-of-type(1){
        width: 100px;
        word-break:break-all;
      }
      span:nth-of-type(2){
        // width: 220px;
        word-break: break-all;
      }
    }
    img {
      position: absolute;
      width: 133px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .remark {
      position: relative;
      display: flex;
      align-items: flex-start;
      > span:nth-of-type(1) {
        width: 78px;
        align-items: flex-start;
        white-space: nowrap;
        >span{
          color: transparent;
        }
      }
      .remarkWord {
        color: rgb(45, 45, 45);
        width: 80%;
        font-weight: bold;
        text-align: right;
      }
    }
    .money {
      > span:nth-of-type(2) {
        font-weight: 600;
        color: #e53500;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
    }
  }
  .cu-form-group {
    margin-top: 5px;
    border-top: 2px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    padding: 0px 10px;
    align-items: center;
    position: relative;
    > div {
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1989fa;
      padding: 10px 0;
    }
  }
}

.model {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.3;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  overflow: hidden;
}

.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}

.dialog {
  ::v-deep .van-field__label {
    width: 110px !important;
  }
}	
</style>
